import request from '@/utils/request'

//  新增/修改网店
export const addOrUpdateOnlineStore = (formData) => {
    return request.post('/onlineStore', formData)
}

//  修改网店
export const editOrUpdateOnlineStore = (updateData) => {
    return request.put('/onlineStore', updateData)
}

//  查询网店
export const onlineStoreList = (pageData, formData) => {
    return request.get(`/onlineStore/${pageData.page}/${pageData.pageSize}`, {params:{name:formData.name}})
}

//  查询网店详情
export const onlineStoreDetail = (id) => {
    return request.get(`/onlineStore/${id}`)
}

//  删除网店
export const onlineStoreDelete = (id) => {
    return request.delete(`/onlineStore/${id}`)
}